import { render, staticRenderFns } from "./locator.vue?vue&type=template&id=2c4acafb&scoped=true&"
import script from "./locator.vue?vue&type=script&lang=js&"
export * from "./locator.vue?vue&type=script&lang=js&"
import style0 from "./locator.vue?vue&type=style&index=0&id=2c4acafb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4acafb",
  null
  
)

export default component.exports